import React from 'react'
import Navbar from './Components/Navbar'
import Home from './Components/Home'
import Services from './Components/Services'
import AboutUs from './Components/AboutUs'
import Contact from './Components/Contact'
import Footer from './Components/Footer'
import Review from './Components/Review'
import Gallery from './Components/Gallery'

const App = () => {
  return (
    <div>
      <Navbar />
      <Home />
      <Services/>
      <AboutUs/>
      <Gallery/>
      <Review/>
      <Contact/>
      <Footer/>
    </div>
  )
}

export default App